module.exports = __webpack_public_path__ + "res/Roboto-Light-webfont.woff?e95e16e75b428650c57b0a7b5b75a395";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/roboto/Roboto-Light-webfont.woff
// module id = 68
// module chunks = 0